import { MenuItem } from 'primeng/api';

export const SWIADCZENIOBIORCY_MENU_ITEM: MenuItem[] = [
  {
    label: 'Aktywny Rodzic',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar1',
    },
  },
  {
    label: 'Świadczenia Wychowawcze',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar2',
    },
  },
  {
    label: 'Świadczenia Rodzinne',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar3',
    },
  },
  {
    label: 'Dobry Start',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar4',
    },
  },
  {
    label: 'Karta Dużej Rodziny',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar5',
    },
  },
  {
    label: 'Fundusz Alimentacyjny',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar6',
    },
  },
  {
    label: 'Pomoc Społeczna',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar7',
    },
  },
  {
    label: 'Świadczenia Wspierające',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar8',
    },
  },
];

export const PRZEDZSIEBIORCY_MENU_ITEM: MenuItem[] = [
  {
    label: 'Opieka nad dzieckiem do lat 3',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar9',
    },
  },
  {
    label: 'Turnusy Rehabilitacyjne',
    action: () => {},
    state: {
      section: 'uslugiPoZalogowaniuObszar10',
    },
  },
];
